import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { Skeleton } from '@/components/ui/skeleton'
import { useAuth } from '@/lib/auth'
import { useTenant } from '@/lib/tenant'

export default function ProtectedLayout() {
  const { user, isLoading, isAuthenticated } = useAuth()
  const tenant = useTenant()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Skeleton className="h-8 w-48" />
      </div>
    )
  }

  // Not authenticated → redirect to tenant login
  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/${tenant.slug}/login?redirect=${redirect}`} replace />
  }

  // Tenant mismatch check (superadmin can access any tenant)
  if (user?.role !== 'superadmin' && user?.tenantSlug !== tenant.slug) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-4">
        <h1 className="text-2xl font-bold">アクセス権がありません</h1>
        <p className="text-muted-foreground">このテナントへのアクセス権がありません。</p>
      </div>
    )
  }

  return <Outlet />
}
